import { Platform, View, StyleSheet } from "react-native";

export const BlurView = ({ children, style, intensity = 20 }: any) => {
  if (Platform.OS === "web") {
    return (
      <View
        style={[
          style,
          styles.webBlur,
          { backdropFilter: `blur(${intensity}px)` },
        ]}
      >
        {children}
      </View>
    );
  }
};

const styles = StyleSheet.create({
  webBlur: {
    backgroundColor: "rgba(255,255,255,0.3)", // semi-transparente
  },
});
